import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  type ActivationAskResponse,
  type SupplierActivationPayload,
} from '../types';
import { zodActivationAskResponseSchema } from '../validations';

/**
 * Creates a planned (draft) activation request for the given data exchange.
 *
 * Uses the same payload as the direct activation endpoint but saves the request
 * as a draft rather than sending it immediately.
 *
 * Returns the batch activation status envelope.
 *
 * @param deId - The data exchange ID of the supplier.
 * @param payload - The activation plan payload.
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The created activation batch(es).
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/post_supplier_activation_plan_suppliers__de_id__activation_plan_post
 */
export const postSupplierActivationPlan = async (
  deId: UUID,
  payload: SupplierActivationPayload,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .post(ENDPOINT.SUPPLIER.POST_ACTIVATION_PLAN(deId), {
      ...options,
      json: payload,
      validate: {
        ...options?.validate,
        response: zodActivationAskResponseSchema,
      },
    })
    .json<ActivationAskResponse>();
